import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_report_table extends PureComponent {
  render() {
    return (
      <div className="row" id="component_report_table">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Report Table</h2>
              <p>
                Report tables show one row per record in a table or data object.
                When viewing a report, only a defined number of rows will
                download. A show more button will appear if there are more
                available. Text values will have the new line and " characters
                removed. If the user has the correct permissions, it is possible
                to download the data as a CSV. Downloading as a CSV will
                download the entire table. The display output max rule will be
                ignored when downloading a CSV.
              </p>
              <InterfaceCompatibility
                dashboard={true}
                record={true}
                report={true}
                search={true}
              />
              <InterfaceProperties
                type={"report_table"}
                name={"report table"}
                searchGroup={false}
                padding={true}
                hide={true}
                order={true}
                tabIndex={false}
                sourceUrl={true}
                sourceDebug={true}
                sourceAggs={true}
                sourceJoin={true}
                displaySort={true}
                properties={[
                  {
                    property: "display_output",
                    description:
                      "Display output is mechanism of mapping results from the API to a table users can view. Display output is an array of objects (one object per column in report). The table below will outline the properties for the display output column objects.",
                    defaults: "[{ ... }, { ... }] default is []",
                  },
                  {
                    property: "display_link",
                    description:
                      "Display link allows users to click a row of the report table to navigate to the view / edit record page.",
                    defaults: "true, false default is false",
                  },

                  {
                    property: "height",
                    description:
                      'Set the height of the report in a record, search, or dashboard page. Reports in the Reports section of the application are not height restricted. "dashboard" auto sizes height to fill a layout card.',
                    defaults: '30 - 2000, "auto" or "dashboard" default is 400',
                  },
                  {
                    property: "display_small",
                    description:
                      "By default, tables with less than 200 rows will have row compression turned off. This setting forces table row height compression on, even in small tables. ",
                    defaults: "true, false default is false",
                  },
                  {
                    property: "display_header",
                    description:
                      "Show the column header at the top of the report. ",
                    defaults: "true, false default is true",
                  },
                ]}
              />

              <h3>Table Output Properties</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>

                  <tr>
                    <td className="b">data</td>
                    <td>
                      <i
                        className="material-icons"
                        style={{
                          display: "inline-block",
                          height: 24,
                          position: "relative",
                          top: 6,
                          fontSize: 24,
                          color: "#F57C00",
                        }}
                      >
                        warning
                      </i>
                      Field in the database bound to this component.
                      <br />
                      <i>
                        "text_my_db_text_field" or "long_my_db_number_field" or
                        "object_my_obj.text_my_text_field"
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">name</td>
                    <td>
                      Name of the column in the report.
                      <br />
                      <i>"My Column" default is ""</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">type</td>
                    <td>
                      Type controls how the data will be displayed. Options
                      include "text", "number", "boolean", "date",
                      "datetime","dateiso", "datetimeiso", "time" and
                      "currency".
                      <br />
                      <i>
                        "text", "number", "boolean", "date",
                        "datetime","dateiso", "datetimeiso", "time", "currency"
                        default is "text"
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">display_size</td>
                    <td>
                      Display size sets the number of rows that will be
                      retrieved from the API server. In the event there are more
                      records than the number of rows retrieved a "show more"
                      button will appear.
                      <br />
                      <i>1-10000, false defaut is 1000</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">order</td>
                    <td>
                      The order the columns will be displayed in. If two columns
                      have the same order number the report will sort by column
                      name.
                      <br />
                      <i>1 - 10000 default is 100</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">rtl</td>
                    <td>
                      Display data in column right to left. This is best
                      practice for numbers and currency.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">sortable</td>
                    <td>
                      Sortable gives the user the option to sort the column
                      after the data has been loaded. Sortable is handled in the
                      interface as opposed to the database and therefore
                      supports sorting text. Sortable will only sort data that
                      has been already loaded loading more data using the "show
                      more" button will add unsorted data.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">decimals</td>
                    <td>
                      Numbers in elasticsearch are stored as integers. Nexoid
                      offers a decimals properties to shift the decimal point. A
                      decimal value of 2 is the equivalent of dividing the
                      number by 100, 3 is the equivalent of dividing by 1000.
                      <br /> decimals is only compatible with "number" type
                      <br />
                      <i>1-8, false default is 0</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">max</td>
                    <td>
                      Max reduces text to a maximum length. Max is only
                      compatible with "text" type columns.
                      <br />
                      <i>1-10000, false default is -1</i>
                    </td>
                  </tr>

                  <tr>
                    <td className="b">value_color_eval</td>
                    <td>
                      Change the color of the value using an eval function.
                      <br />
                      <i>
                        (event.value === 'John Smith' ? '#D32F2F' : undefined)
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">value_color</td>
                    <td>
                      Set the value color.
                      <br />
                      <i>#D32F2F", "#1B5E20" default is "#757575"</i>
                    </td>
                  </tr>

                  <tr>
                    <td className="b">map</td>
                    <td>
                      Map is set of find and replace options that can be run
                      after all other display rules. This can be useful if you
                      have say a priority field which is stored in numbers but
                      you want to be displayed as text. Map is an array of
                      objects each object needs to have a "find" and "replace"
                      property. Both find and place can be either strings or
                      numbers.
                      <br />
                      <i>
                        [&#123; "find": 1, "replace: "High" &#125;, &#123;
                        "find": 2, "replace: "Low" &#125;], false default is []
                      </i>
                    </td>
                  </tr>
                </tbody>
              </table>

              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Report Table Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Report</h3>
              <p>This report returns a list of users.</p>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"report_table"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"source_url_api"</span>:{" "}
                  <span className="jsonY">"user"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"source_url_api_system_object"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_output"</span>: [
                </div>
                <div className="i2">&#123;</div>
                <div className="i3">
                  <span className="jsonG">"data"</span>:{" "}
                  <span className="jsonY">"text_username"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"Username"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"type"</span>:{" "}
                  <span className="jsonY">"text"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>
                </div>
                <div className="i2">&#125;,</div>
                <div className="i2">&#123;</div>

                <div className="i3">
                  <span className="jsonG">"data"</span>:{" "}
                  <span className="jsonY">"text_first_name"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"Name"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"type"</span>:{" "}
                  <span className="jsonY">"text"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">2</span>
                </div>

                <div className="i2">&#125;</div>
                <div className="i1">],</div>

                <div className="i1">
                  <span className="jsonG">"display_sort"</span>:{" "}
                  <span className="jsonY">"text_username"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_link"</span>:{" "}
                  <span className="jsonP">false</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>

            <section>
              <h3>Example 2: Simple Join</h3>
              <p>
                This report returns a list of sales and joins it to the customer
                table to retrive the customers nameThis report returns a list of
                sales and joins it to the customer table to retrieve the
                customer's name.
              </p>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"report_table"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"source_url_api"</span>:{" "}
                  <span className="jsonY">"sale"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"source_join"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"myjoin"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"source_url_api"</span>:{" "}
                  <span className="jsonY">"customer"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"source_primary_id"</span>:{" "}
                  <span className="jsonY">"object_customer.text_id"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"source_output"</span>: [
                  <span className="jsonY">"text_name"</span>]
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;,</div>
                <div className="i1">
                  <span className="jsonG">"display_output"</span>: [
                </div>
                <div className="i2">&#123;</div>
                <div className="i3">
                  <span className="jsonG">"data"</span>:{" "}
                  <span className="jsonY">"myjoin.record.text_name"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"Customer"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"type"</span>:{" "}
                  <span className="jsonY">"text"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>
                </div>
                <div className="i2">&#125;,</div>
                <div className="i2">&#123;</div>
                <div className="i3">
                  <span className="jsonG">"data"</span>:{" "}
                  <span className="jsonY">"text_subject"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"Subject"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"type"</span>:{" "}
                  <span className="jsonY">"text"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">2</span>
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">],</div>
                <div className="i1">
                  <span className="jsonG">"display_sort"</span>:{" "}
                  <span className="jsonY">"text_username"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_link"</span>:{" "}
                  <span className="jsonP">false</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>

            <section>
              <h3>Example 3: Joins</h3>
              <p>
                This report aggregates the "won" sales together, summing the
                sale price, and then joins the ower id to the system user table
                to get their first name.{" "}
              </p>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"report_table"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"source_url_api"</span>:{" "}
                  <span className="jsonY">"sale"</span>,
                </div>

                <div className="i1">
                  <span className="jsonG">"source_query"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"term"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"text_status"</span>:{" "}
                  <span className="jsonY">"won"</span>
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;,</div>

                <div className="i1">
                  <span className="jsonG">"source_aggs"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"my_agg"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"terms"</span>: &#123;
                </div>
                <div className="i4">
                  <span className="jsonG">"field"</span>:{" "}
                  <span className="jsonY">"object_owner.long_id"</span>
                </div>
                <div className="i3">&#125;,</div>

                <div className="i3">
                  <span className="jsonG">"aggs"</span>: &#123;
                </div>
                <div className="i4">
                  <span className="jsonG">"my_sum"</span>: &#123;
                </div>
                <div className="i5">
                  <span className="jsonG">"sum"</span>: &#123;
                </div>
                <div className="i6">
                  <span className="jsonG">"field"</span>:{" "}
                  <span className="jsonY">"long_amount"</span>
                </div>
                <div className="i5">&#125;</div>
                <div className="i4">&#125;</div>
                <div className="i3">&#125;</div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;,</div>

                <div className="i1">
                  <span className="jsonG">"source_join"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"myjoin"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"source_url_api"</span>:{" "}
                  <span className="jsonY">"user"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"source_url_api_system_object"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"source_primary_id"</span>:{" "}
                  <span className="jsonY">"key"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"source_output"</span>: [
                  <span className="jsonY">"text_first_name"</span>,{" "}
                  <span className="jsonY">"text_last_name"</span>]
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;,</div>
                <div className="i1">
                  <span className="jsonG">"display_output"</span>: [
                </div>

                <div className="i2">&#123;</div>
                <div className="i3">
                  <span className="jsonG">"data"</span>:{" "}
                  <span className="jsonY">"myjoin.record.text_first_name"</span>
                  ,
                </div>
                <div className="i3">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"First name"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"sortable"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>
                </div>
                <div className="i2">&#125;,</div>
                <div className="i2">&#123;</div>
                <div className="i3">
                  <span className="jsonG">"data"</span>:{" "}
                  <span className="jsonY">"myjoin.record.text_last_name"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"Last name"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"sortable"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">2</span>
                </div>
                <div className="i2">&#125;,</div>
                <div className="i2">&#123;</div>
                <div className="i3">
                  <span className="jsonG">"data"</span>:{" "}
                  <span className="jsonY">"my_sum.value"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"Value"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"type"</span>:{" "}
                  <span className="jsonY">"currency"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"sortable"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">3</span>
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">],</div>
                <div className="i1">
                  <span className="jsonG">"display_sort"</span>:{" "}
                  <span className="jsonY">"my_sum.value"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_sort_up"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_link"</span>:{" "}
                  <span className="jsonP">false</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_report_table;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_report_table.js